import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/_components/BookingSystem.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/_components/common/LoadingPage.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/_components/common/SliderMain.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/_components/ElgiwarFeatures.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/_components/Offers.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/_components/OurLocation.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/_components/WhyUs.jsx");
